const audio = new Audio();

export const canPlayFile = (mimeType: string) => {
    const canPlay = audio.canPlayType(mimeType);
    return canPlay !== '';
};
